import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./auth/auth.css";
import ResetPassword from "./ResetPassword";
import { API_KEY, BASE_URL, AUTH_BASE_URL } from "./config";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      setError(null);

      const res = await fetch(`${AUTH_BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        setError("Reset expiry token generation failed");
        return;
      }

      const token = await res.text(); // ✅ FIX
      setToken(token);
      setMessage("Password reset token received. Please update your password.");

    } catch (err) {
      console.error("reset password exception:", err);
      setError("Reset password exception");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-title">Forgot Password</div>
        <div className="auth-subtitle">We’ll help you reset it</div>

        {message && <div className="auth-success">{message}</div>}
        {error && <div className="auth-error">{error}</div>}

        {!token && (
          <>
            <input
              className="auth-input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button className="auth-btn" onClick={handleSubmit}>
              Send Reset Link
            </button>
          </>
        )}

        {/* ✅ Correct rendering */}
        {token && <ResetPassword expiryToken={token} />}

        <div className="auth-links">
          <span onClick={() => navigate("/login")}>Back to Login</span>
        </div>

        <div className="auth-links">
          Back to <span onClick={() => navigate("/")}>Home</span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
